import r from "../../shared-lib/braze-shared-lib.js";
export function getByteLength(t) {
  let e = t.length;
  for (let r = t.length - 1; r >= 0; r--) {
    const n = t.charCodeAt(r);
    n > 127 && n <= 2047 ? e++ : n > 2047 && n <= 65535 && (e += 2),
      n >= 56320 && n <= 57343 && r--;
  }
  return e;
}
export function decodeBrazeActions(t) {
  try {
    t = t.replace(/-/g, "+").replace(/_/g, "/");
    const e = window.atob(t),
      r = new Uint8Array(e.length);
    for (let t = 0; t < e.length; t++) r[t] = e.charCodeAt(t);
    const n = new Uint16Array(r.buffer);
    return String.fromCharCode(...n);
  } catch (t) {
    return r.j.error("Unable to decode Base64: " + t), null;
  }
}
